import React from 'react';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../Basic/Button';

const useStyles = makeStyles(() => ({
  root: {
    '& .position-button': {
      color: 'var(--color-colorPrimary-main)',
      border: `1px solid ${'var(--color-colorPrimary-main)'}`,
      backgroundColor: 'var(--color-notification-position-bg)',
      height: 38,

      '&:hover': {
        backgroundColor: 'var(--color-notification-position-bg)',
      },
    },
  },
}));

const Position = ({ snackbarPositionToggle }) => {
  const classes = useStyles();

  const handleClick = () => {
    snackbarPositionToggle();
  };

  return (
    <div className={classes.root}>
      <Button
        onClick={handleClick}
        variant="contained"
        color="white"
        className="position-button"
      >
        <ChevronLeftIcon />
      </Button>
    </div>
  );
};

export default Position;
